module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "回收权益",
      "visible": _vm.visible,
      "before-close": _vm.handleClose,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.formInfo,
      "label-width": "120px",
      "label-position": "right",
      "size": "small",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回收地址"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.url),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "url", $$v)
      },
      expression: "formInfo.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户",
      "prop": "subscriberId"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.subscriberId),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "subscriberId", $$v)
      },
      expression: "formInfo.subscriberId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益卡",
      "prop": "PrivilegeCardId"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.PrivilegeCardId),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "PrivilegeCardId", $$v)
      },
      expression: "formInfo.PrivilegeCardId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-f161b396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/privilege/subscriber/components/recycling.vue
// module id = 1765
// module chunks = 0